import { useRouteTracker } from "./useRouteTracker";
var RouteTracker = function () {
    useRouteTracker();
    return null;
};
export default RouteTracker;
